import { render, staticRenderFns } from "./MWidgetLinkStats.vue?vue&type=template&id=741a7d2d&lang=pug&"
import script from "./MWidgetLinkStats.vue?vue&type=script&lang=js&"
export * from "./MWidgetLinkStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports